module.exports = __webpack_public_path__ + "static/media/picture-(124).ee04e2ce.JPG";